import React from "react";
import { useRecordContext } from "react-admin";
import { styled } from "@mui/material/styles";

const CancelledWrapper = styled("span")(({ theme }) => ({
  color: "rgba(40,40,40,.3)",
  textDecorationLine: "line-through",
}));

export const withDisabledIfCancelled = (WrappedComponent) => (props) => {
  const record = useRecordContext();
  const isCancelled = record?.status === "cancelled";

  if (isCancelled) {
    return (
      <CancelledWrapper>
        <WrappedComponent {...props} />
      </CancelledWrapper>
    );
  }

  return <WrappedComponent {...props} />;
};
